// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.circulations {
  background-color: var(--light-gray);
  width: 100%;
  height: 500px;
}

.circulations__filter {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/modules/circulations/circulation-list/Circulations.scss","webpack://./src/modules/circulations/circulation-list/Circulations.css"],"names":[],"mappings":"AAAA;EACE,mCAAmC;EACnC,WAAW;EACX,aAAa;ACCf;;ADCE;EAGE,aAAa;ECIP,yBAAyB;EACjC,mBAAmB;AACrB","sourcesContent":[".circulations {\n  background-color: var(--light-gray);\n  width: 100%;\n  height: 500px;\n\n  &__filter {\n    display: flex;\n    justify-content: flex-end;\n    margin-bottom: 20px;\n  }\n}",".circulations {\n  background-color: var(--light-gray);\n  width: 100%;\n  height: 500px;\n}\n\n.circulations__filter {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  margin-bottom: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
